import React from 'react'
import Icon from '../../atoms/Icon/Icon'
import LoadingSvg from '../Loading/Loading'
import WLink from '../WLink/WLink'

const Button = ({
  label = undefined,
  variant = 'ghost',
  colorVariant = undefined,
  size = 'medium',
  responsive = false,
  icon = undefined,
  bg = undefined,
  color = undefined,
  icon_name = undefined,
  icon_size = undefined,
  icon_pos = 'right',
  onClick = undefined,
  disabled = false,
  className = undefined,
  type = 'button',
  href = undefined,
  target = undefined,
  newPage = false,
  loading = undefined,
  noPointer = undefined,
  ariaLabel = undefined,
  next = false,
  download = undefined,
}) => {
  const ButtonIcon = () => (icon ? icon : <Icon icon_name={icon_name} size={icon_size} />)

  const classNames =
    `button button__${variant ? variant : 'ghost'} button__${size ? size : 'medium'}` +
    (responsive ? ' button__' + size + '--responsive' : '') +
    (colorVariant ? ' button--' + colorVariant : '') +
    (noPointer ? ' button__no-pointer' : '') +
    (className ? ' ' + className : '')

  const getContent = () => (
    <>
      {((loading && !href) || icon || icon_name) && (
        <div className={`button__icon button__icon--${icon_pos === 'left' ? 'left' : 'right'}`}>
          {loading ? (
            <div style={{ alignSelf: 'center' }}>
              <LoadingSvg width={24} color={variant === 'primary' || !variant ? 'white' : null} />
            </div>
          ) : (
            <ButtonIcon style={{ alignSelf: 'center' }} />
          )}
        </div>
      )}
      <span className="button__label">{label}</span>
    </>
  )

  const getStyle = () => ({
    order: 0,
    ...(bg ? { backgroundColor: bg } : {}),
    ...(color ? { color } : {}),
  })

  return href && !disabled ? (
    <WLink
      href={href}
      newPage={newPage || target === "_blank"}
      className={classNames}
      download={download}
      style={getStyle()}
      ariaLabel={ariaLabel}
      next={next}
    >
      {getContent()}
    </WLink>
  ) : (
    <button
      type={type}
      disabled={disabled}
      onClick={(e) => {
        if (!loading && !!onClick) onClick(e)
      }}
      className={classNames}
      style={getStyle()}
      aria-label={ariaLabel}
    >
      <div className="button__content">{getContent()}</div>
    </button>
  )
}

export default React.memo(Button)
